// extracted by mini-css-extract-plugin
export default {"select":"alt__select___jCKuG"};